import {faker}  from "@faker-js/faker";
import { getAccounts } from "../helpers/get-accounts";
import { desiredStatePolicies, desiredStateRules } from "./desired-state-list";
import { convertString } from "../../utils/desired-state-policy";

var regionCodes = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
];

export const allDesiredStatePolicies = async () => {
  let desiredStatePolicy = [];
  let accounts = await getAccounts();
  let AccountNumber = faker.helpers.arrayElement(accounts);
  let RegionCode = faker.helpers.arrayElement(regionCodes);

  desiredStatePolicies.forEach((policy) => {
    const desiredState = {
      Description: policy.Description,
      ID: policy.ID || "",
      Name: policy.Name,
      Type: policy.Type,
      Rules: allDesiredStateRules(),
    };

    desiredState.ID = policy.ID
      ? policy.ID
      : `arn:aws:ssm:${RegionCode}:${AccountNumber}:desirestatepolicy/${faker.random.alphaNumeric(
          10
        )}`;
    desiredStatePolicy.push(desiredState);
  });
  return desiredStatePolicy;
};

export const allDesiredStateRules = () => {
  let desiredStatePolicyRules = [];
  desiredStateRules.forEach((rule) => {
    const desiredStateRule = {
      RuleName: rule.RuleName,
      RuleType: rule.RuleType,
      Platform: rule.Platform,
      ComplianceSeverity: convertString(rule.ComplianceSeverity, true),
      RuleId: rule.RuleId,
      Remediation: rule.Remediation,
      Type: rule.Type,
      Parameters: rule.Parameters,
      desiredStateRuleFilesCheck: rule.desiredStateRuleFilesCheck,
      desiredStateRuleWindowsRegistry: rule.desiredStateRuleWindowsRegistry,
      parameterMetaData: rule.parameterMetaData,
      remediationEnabled: rule.remediationEnabled,
      windowsScript: rule.windowsScript,
      remediationScript: rule.remediationScript,
      switchDssRuleOs: rule.switchDssRuleOs,
    };
    desiredStatePolicyRules.push(desiredStateRule);
  });
  return desiredStatePolicyRules;
};

export const desiredStatePolicyData = (desiredStatePolicy) => {
  const data = {
    ID: desiredStatePolicy.ID,
    Name: desiredStatePolicy.Name,
    ResponseMetadata: {
      RetryAttempts: 0,
      HTTPStatusCode: 200,
      RequestId: "d4fcc672-fb87-400f-ad03-e403e139e3d1",
      HTTPHeaders: {
        "x-amzn-requestid": "d4fcc672-fb87-400f-ad03-e403e139e3d1",
        date: "Thu,16 May 2019 06:17:48 GMT",
        "content-length": "789",
        "content-type": "application/x-amz-json-1.1",
      },
    },
    Type: desiredStatePolicy.Type,
    Description: desiredStatePolicy.Description,
    Rules: desiredStatePolicy.Rules,
  };
  return data;
};

export const saveDesiredPolicyData = async (desiredStatePolicy) => {
  let account = faker.helpers.arrayElement(await getAccounts());
  let region = faker.helpers.arrayElement(regionCodes);
  let policyType = Array.isArray(desiredStatePolicy.Type)
    ? desiredStatePolicy.Type[0]
    : desiredStatePolicy.Type;
  let newPolicy = {
    Description: desiredStatePolicy.Description,
    ID: desiredStatePolicy.ID
      ? desiredStatePolicy.ID
      : `arn:aws:ssm:${region}:${account}:desirestatepolicy/${faker.random.alphaNumeric(
          10
        )}`,
    Name: desiredStatePolicy.Name,
    Type: policyType,
    Rules: desiredStatePolicy.Rules,
  };
  return newPolicy;
};
